<!-- Selftest Form -->
@if (selftestForm) {
  <medsurf-design-form-control-form
    [formGroup]="selftestForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <!-- Use For Selftest -->
    <medsurf-design-form-control-input-checkbox [control]="selftestForm.controls.ignore"
      [label]="'global.self_test_used_for'"
      [trueValue]="false"
      [falseValue]="true"
      [class]="'w-full'"
    (valueChange)="onSubmit()"></medsurf-design-form-control-input-checkbox>
  </medsurf-design-form-control-form>
}